import { moduleFactory } from "@/factories/module";
import {
  electronBindingNavigateToExternalUrl,
  electronBindingNavigateToInternalUrl,
  electronBindingFindInPage,
  electronBindingStopFindInPage,
  electronBindingOnFindInPageResult,
  electronBindingToggleMenu,
  electronBindingUpdateNow,
  electronBindingMinimizeWindow,
  electronBindingMaximizeWindow,
  electronBindingCloseWindow,
  electronBindingRestartApp,
  electronBindingOpenSystemSoundSettings,
  recallBindingPrepareDesktopRecording,
  recallBindingStartRecording,
  recallBindingPauseRecording,
  recallBindingResumeRecording,
  recallBindingStopRecording,
  recallBindingOnEvent,
  recallBindingGetPermissionStatus,
  recallBindingRequestPermission,
  recallBindingOnPermissionStatus,
  recallBindingOpenPermissionPane,
} from "@/modules/electron/bindings";

export const electronModule = moduleFactory.create({
  navigateToInternalUrl: electronBindingNavigateToInternalUrl,
  navigateToExternalUrl: electronBindingNavigateToExternalUrl,
  findInPage: electronBindingFindInPage,
  stopFindInPage: electronBindingStopFindInPage,
  onFindInPageResult: electronBindingOnFindInPageResult,
  toggleMenu: electronBindingToggleMenu,
  minimizeWindow: electronBindingMinimizeWindow,
  maximizeWindow: electronBindingMaximizeWindow,
  closeWindow: electronBindingCloseWindow,
  updateNow: electronBindingUpdateNow,
  restartApp: electronBindingRestartApp,
  openSystemSoundSettings: electronBindingOpenSystemSoundSettings,
  recall: {
    prepareDesktopRecording: recallBindingPrepareDesktopRecording,
    startRecording: recallBindingStartRecording,
    pause: recallBindingPauseRecording,
    resume: recallBindingResumeRecording,
    stop: recallBindingStopRecording,
    onEvent: recallBindingOnEvent,
    getPermissionStatus: recallBindingGetPermissionStatus,
    requestPermission: recallBindingRequestPermission,
    onPermissionStatus: recallBindingOnPermissionStatus,
    openPermissionPane: recallBindingOpenPermissionPane,
  },
});
